import { defaultApiState } from '../api.state';

export const usefulLinkMutations = {
  GET_USEFUL_LINKS_LOADING(state) {
    state.apiState.getUsefulLinks = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_USEFUL_LINKS_SUCCESS(state, payload) {
    state.apiState.getUsefulLinks = {
      ...defaultApiState,
      success: true,
    };
    state.usefulLinks = payload;
  },
  GET_USEFUL_LINKS_ERROR(state, error) {
    state.apiState.getUsefulLinks = {
      ...defaultApiState,
      error,
    };
  },

  ADD_USEFUL_LINK_LOADING(state) {
    state.apiState.addUsefulLink = {
      ...defaultApiState,
      loading: true,
    };
  },
  ADD_USEFUL_LINK_SUCCESS(state) {
    state.apiState.addUsefulLink = {
      ...defaultApiState,
      success: true,
    };
  },
  ADD_USEFUL_LINK_ERROR(state, error) {
    state.apiState.addUsefulLink = {
      ...defaultApiState,
      error,
    };
  },

  GET_USEFUL_LINK_RESET(state) {
    state.apiState.getUsefulLink = {
      ...defaultApiState,
    };
    state.usefulLink = undefined;
  },
  GET_USEFUL_LINK_LOADING(state) {
    state.apiState.getUsefulLink = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_USEFUL_LINK_SUCCESS(state, payload) {
    state.apiState.getUsefulLink = {
      ...defaultApiState,
      success: true,
    };
    state.usefulLink = payload;
  },
  GET_USEFUL_LINK_ERROR(state, error) {
    state.apiState.getUsefulLink = {
      ...defaultApiState,
      error,
    };
  },

  UPDATE_USEFUL_LINK_LOADING(state) {
    state.apiState.updateUsefulLink = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_USEFUL_LINK_SUCCESS(state) {
    state.apiState.updateUsefulLink = {
      ...defaultApiState,
      success: true,
    };
  },
  UPDATE_USEFUL_LINK_ERROR(state, error) {
    state.apiState.updateUsefulLink = {
      ...defaultApiState,
      error,
    };
  },

  DELETE_USEFUL_LINK_LOADING(state) {
    state.apiState.deleteUsefulLink = {
      ...defaultApiState,
      loading: true,
    };
  },
  DELETE_USEFUL_LINK_SUCCESS(state, payload) {
    state.apiState.deleteUsefulLink = {
      ...defaultApiState,
      success: true,
    };
    state.usefulLinks = state.usefulLinks.filter(o => o.id !== payload.id);
  },
  DELETE_USEFUL_LINK_ERROR(state, error) {
    state.apiState.deleteUsefulLink = {
      ...defaultApiState,
      error,
    };
  },
};
